import { apiService } from 'core/services/apiService';
import { getAdminBaseUrl } from 'core/config/adminBaseUrl';
import { ISchedule } from 'module/schedule/interfaces/ScheduleInterface';
import axios from 'axios';
import { getAdminAuthHeaders } from 'core/utils/adminAuthHeaders';
import moment from 'moment';

export interface deleteConfig {
    id: any;
}

export interface editConfig {
    id: any;
    screenGroup?: any;
}

const GetGameMasterData = async (workplaceId?: number): Promise<any> => {
    const id = workplaceId || Number(localStorage.getItem("workplace-id")) || 1;
    const { ...data } = apiService.responseHandler(
        await apiService.get(`game_master_event_planners?pagination=false&workplace=${id}`)
    );

    return data;
};

const DeleteGameMasterData = async (deleteConfig: deleteConfig): Promise<any> => {
    const { ...data } = apiService.responseHandler(
        await apiService.delete(`game_master_event_planners/${deleteConfig.id}`)
    );

    return data;
};

const SaveGameMasterData = async (editConfig: editConfig): Promise<any> => {
    console.log(editConfig.screenGroup);
    const { ...data } = apiService.responseHandler(
        await apiService.put(`game_master_planners/screen/${editConfig.id}`, {screenGroup: editConfig.screenGroup} )
    );

    return data;
};

export interface CreateProgramData {
    screen_group_name: string;
    screen_group_id: number;
    start_time: string;
    end_time: string;
    workplace_id: number;
    fill_sports: boolean;
}

export interface SaveSelectedProgramData {
    workplace: {
        id: number;
    };
    screen_group: {
        id: number;
    };
    tms_id: string;
    sport: {
        id: number;
        label: string;
    };
    sub_type: string;
    title: string;
    event_title: string;
    long_description: string;
    duration: number;
    call_sign: string;
    channel: string;
    team_one: number | null;
    team_two: number | null;
    start_time: string;
    end_time: string;
    game_date: string;
    game_time: string | null;
    game_time_zone: string | null;
    scheduled: boolean;
    live: boolean;
    playoffs: boolean;
    favorite_team: boolean;
    local_start_time: string;
    local_end_time: string;
    converted_local_start_datetime: string | null;
    converted_local_end_datetime: string | null;
    event_score: number | null;
}

const CreateProgram = async (data: CreateProgramData): Promise<any> => {
    const response = await axios.post(
        `${getAdminBaseUrl()}/gamemaster-scheduler/api/fill-gap-api`,
        data,
        {
            headers: getAdminAuthHeaders({ 'Content-Type': 'application/json' }),
        }
    );
    return response;
};

const SaveSelectedProgram = async (data: SaveSelectedProgramData): Promise<any> => {
    const response = await axios.post(
        `${getAdminBaseUrl()}/gamemaster-scheduler/api/save-event-api`,
        data,
        {
            headers: getAdminAuthHeaders({ 'Content-Type': 'application/json' }),
        }
    );
    return response;
};

const RebuildSchedule = async (): Promise<any> => {
    const workplaceId = localStorage.getItem('workplace-id');
    const response = await axios.post(
        `${getAdminBaseUrl()}/gamemaster-scheduler/api/generate-schedule-db`,
        null,
        {
            headers: getAdminAuthHeaders({
                ...(workplaceId && { 'X-Workplace-Id': workplaceId }),
                'X-Days': '4',
            }),
        }
    );
    return response;
};

const GetGameMasterStats = async (workplaceId?: number, date?: string): Promise<any> => {
    const id = workplaceId || Number(localStorage.getItem("workplace-id")) || 1;
    const dateParam = date || moment().format("YYYY-MM-DD");
    const { ...data } = apiService.responseHandler(
        await apiService.get(`game_master_stats?workplace=${id}&date=${dateParam}`)
    );

    return data;
};

export {
    GetGameMasterData,
    DeleteGameMasterData,
    SaveGameMasterData,
    CreateProgram,
    SaveSelectedProgram,
    RebuildSchedule,
    GetGameMasterStats,
};
